import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import api, { apiErr } from "../lib/api";
import { formatGs } from "../lib/format";
import { BadgeDollarSign } from "lucide-react";
import { toast } from "sonner";

export function ConfirmFlete({ envio, onClose, onDone }) {
  const [monto, setMonto] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (envio) setMonto(String(envio.costo_envio ?? 40000)); }, [envio]);

  const confirm = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post(`/envios/${envio.id}/confirmar-flete`, { costo_envio: Number(monto) || 0 });
      toast.success(`Flete confirmado: ${formatGs(monto)}`);
      onClose();
      if (onDone) await onDone(envio);
    } catch (e2) { toast.error(apiErr(e2)); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={!!envio} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><BadgeDollarSign className="h-5 w-5 text-[#F5A623]" /> Confirmar flete · {envio?.code}</DialogTitle>
          <DialogDescription>Confirmá o modificá el monto del flete. Recién después estará disponible el aviso al destinatario.</DialogDescription>
        </DialogHeader>
        <form onSubmit={confirm} className="space-y-3">
          <div>
            <label className="text-xs font-semibold text-[#64748B]">Monto del flete (Gs.)</label>
            <input type="number" min="0" step="1000" value={monto} onChange={(e) => setMonto(e.target.value)} required data-testid="flete-monto-input"
              className="w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm outline-none focus:border-[#3B82F6] focus:ring-2 focus:ring-blue-100" />
          </div>
          <button disabled={loading} data-testid="flete-confirm-btn" className="w-full rounded-lg bg-[#0A1F44] hover:bg-[#132D5C] text-white font-semibold py-2.5 text-sm disabled:opacity-60">
            {loading ? "Confirmando..." : "Confirmar flete"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
